import { render, staticRenderFns } from "./IncomeSourcesChart.vue?vue&type=template&id=2d814a44&"
import script from "./IncomeSourcesChart.vue?vue&type=script&lang=ts&"
export * from "./IncomeSourcesChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports